import { t } from './use-i18n/locales/index'

const KEY = 'i18n-locale'

export const getLocale = () => {
  return localStorage.getItem(KEY)
}

export const setLocale = (locale: string) => {
  localStorage.setItem(KEY, locale)
}
/**
 * 获得当前语种信息
 * @returns 当前语种
 */
export const getCurrentLocale = () => {
  const _currentLocale = getLocale()
  let currentLocale = 'zh-cn'
  if (_currentLocale) {
    currentLocale = _currentLocale
  }
  // 服务端跟前端的语种key可能不一致，这里做下特别处理
  if (currentLocale === 'en') {
    currentLocale = 'en-US'
  }
  return currentLocale
}
/**
 * 返回对用国际化内容，没找到则直接返回key
 * @param key 语言key
 * @param preFix 语言key前缀
 * @returns 返回对应国际化内容
 */
export const getLocalLanguageValue = (key: string, preFix = '') => {
  try {
    return t(`${preFix}${key}`, {}, { default: key })
  } catch (error) {
    return key
  }
}
